import React, { useContext, useEffect, useState } from "react";

import { API } from "../../constants/Api";
import { format } from "date-fns";
import { toast } from "react-toastify";
import { Modal, Tooltip } from "antd";
import DataTable from "react-data-table-component";
import { useLocation, useNavigate } from "react-router-dom";
import { ProfileUpdate } from "../../App";

function ZipCodeDetail() {
  const token = localStorage.getItem("token");

  const location = useLocation()
const navigate = useNavigate()
  const {data} = location.state || []; // Combined data for tours and offers
  const {data2} = location.state || []; // Combined data for tours and offers
  const {type} = location.state || ""; // Combined data for tours and offers
  const {zipc} = location.state || ""; // Combined data for tours and offers
  const [agentsData, setAgentsData] = useState([]);
  const [advertisersData, setAdvertisersData] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [user, setUser] = useState([]);
  const [update, setUpdate] = useState(0);
  const [reason, setReason] = useState("");
  const [openResponsive, setOpenResponsive] = useState(false);
  const [openResponsive2, setOpenResponsive2] = useState(false);
  const [openReason, setOpenReason] = useState(false);
  const [openReason2, setOpenReason2] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [activeTab, setActiveTab] = useState("Advertiser");
  const [loading, setLoading] = useState(false);
  const { profileUpdateState, setProfileUpdateState } =
    useContext(ProfileUpdate);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    if (location.state) {
      if (type === "Agents") {
        setAgentsData(location.state.data || []);
      } else {
        setAdvertisersData(location.state.data2 || []);
      }
    }
  }, [location.state]);
  // Fetch data for tours and offers
 
  // Fetch user details

  // Open modal for selected lead
 
  // Handle approve/disapprove actions

  // Columns for DataTable
  // const columns = [
  //   {
  //     name: "Name",
  //     selector: (row) => row.name,

  //     sortable: true,
  //     minWidth: "200px",
  //   },

  //   {
  //     name: "Zip Code",
  //     cell: (row) => (
  //       <span
  //         className="tour-status-completed-1 my-3"
      
  //       >
  //            {zipc}
  //       </span>
  //     ),
  //     sortable: true,
  //     minWidth: "200px",
  //     center: true,
  //   },
  //   {
  //     name: "Email",
  //     selector: (row) => row.email,
  //     sortable: true,
  //     minWidth: "200px",
  //     right: true,
  //   },
 
  

  // ];
   const handleApprove = async (tourId, status) => {
       const data = {
         id: tourId,
         accountStatus: status,
       };
       const loading = toast.loading("Processing...");
       try {
         const response = await fetch(
           `${API}/advertiser/advertisers/account-status`,
           {
             method: "PUT",
             body: JSON.stringify(data),
             headers: {
               "Content-Type": "application/json",
               Authorization: `Bearer ${token}`,
             },
           }
         );
   
         const json = await response.json();
   
         if (response.ok) {
           toast.success(json.message);
           setOpenResponsive(false);
           setUpdate(update + 1);
           const updatedData = advertisersData.map(item => 
            item._id === tourId ? {...item, accountStatus: status} : item
          );
          setAdvertisersData(updatedData);
         } else {
           toast.error(json.message);
         }
       } catch (error) {
         toast.error(error.message);
       } finally {
         toast.dismiss(loading);
         setReason("");
       }
     };
 const handleApprove2 = async (tourId, status) => {
    const data = {
      agentId: tourId,
      accountStatus: status,
    };
    const loading = toast.loading("Processing...");
    try {
      const response = await fetch(`${API}/agents/approved-agent`, {
        method: "PUT",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const json = await response.json();

      if (response.ok) {
        toast.success(json.message);
        setOpenResponsive(false);
        setUpdate(update + 1);
        const updatedData = agentsData.map(item => 
          item._id === tourId ? {...item, accountStatus: status} : item
        );
        setAgentsData(updatedData);
     
      } else {
        toast.error(json.message);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      toast.dismiss(loading);
      setReason("");
    }
  };
  const openTerms = (id) => {
    if (type === "Advertisers") {
      const myData = advertisersData.find((item) => item._id === id);
      if (myData) {
        setSelectedData(myData);
        setOpenResponsive(true);
      }
    } else {
      const myData = agentsData.find((item) => item._id === id);
      if (myData) {
        setSelectedData(myData);
        setOpenResponsive(true);
      }
    }
  };
  const columns = [
    {
      name: "Agent Name",
      selector: (row) => row.agentName,
      cell: (row) => (
        <div className="table-layout-content-header-box">
          <div className="table-layout-content-header-image">
            {row.imageUrl !== null ? (
              <>
                {" "}
                <img
                  src={row.imageUrl !== null ? row.imageUrl : ""}
                  className="table-layout-content-header-image-media img-fluid"
                  alt=""
                />
              </>
            ) : (
              <></>
            )}
          </div>
          <div className="table-layout-content-header-details">
            <h3 className="table-layout-content-header-details-name my-0">
              {row.agentName}
            </h3>
            <p className="table-layout-content-header-details-zipcode my-0">
              {row.agentVendorType === "Transaction Coordinator"
                ? "California"
                : ""}
            </p>
          </div>
        </div>
      ),
      sortable: true,
      minWidth: "300px",
    },

    {
      name: "Zip Code",
      cell: (row) => (
        <span
          className="tour-status-completed-1 my-3"
      
        >
             {zipc}
        </span>
      ),
      sortable: true,
      minWidth: "200px",
      center: true,
    },
    {
      name: "Agent Status",
      selector: (row) => (row.isVerified ? "Verified" : "Un verified"),

      sortable: true,
      minWidth: "200px",
      // right: true
      center: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <button className="tour-cta-1" onClick={() => openTerms(row._id)}>
          Expand
        </button>
      ),
      minWidth: "200px",
      center: true
    },
  ];
  const columns2 = [
    {
      name: "Advertiser Name",
      selector: (row) => row.fulName,
      cell: (row) => (
        <div className="table-layout-content-header-box">
          <div className="table-layout-content-header-image">
            {row.imageUrl !== null ? (
              <>
                {" "}
                <img
                  src={row.imageUrl !== null ? row.imageUrl : ""}
                  className="table-layout-content-header-image-media img-fluid"
                  alt=""
                />
              </>
            ) : (
              <></>
            )}
          </div>
          <div className="table-layout-content-header-details">
            <h3 className="table-layout-content-header-details-name my-0">
              {row.fulName?.slice(0, 25)}
            </h3>
          </div>
        </div>
      ),
      sortable: true,
      minWidth: "300px",
    },

    // {
    //   name: "Type",
    //   selector: (row) => row.titleCompany,
    //   sortable: true,
    //   minWidth: "200px",
    //   center: true,
    // },
    {
      name: "Zip Code",
      cell: (row) => (
        <span
          className="tour-status-completed-1 my-3"
      
        >
             {zipc}
        </span>
      ),
      sortable: true,
      minWidth: "200px",
      center: true,
    },
    {
      name: "Advertiser Status",
      selector: (row) => (row.isVerified ? "Verified" : "Un verified"),

      sortable: true,
      minWidth: "200px",
      // right: true
      center: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <button className="tour-cta-1" onClick={() => openTerms(row._id)}>
          Expand
        </button>
      ),
      minWidth: "200px",
    },
  ];

  // Custom styles for DataTable
  const customStyles = {
    table: {
      style: {
        backgroundColor: "#252525!important",
      },
    },
    headCells: {
      style: {
        backgroundColor: "#1e1e1e",
        color: "#ffffff",
        fontSize: "16px",
        fontFamily: "Degular-Light",
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        color: "#ffffff",
      },
    },
    rows: {
      style: {
        backgroundColor: "#252525",
        fontFamily: "Degular-Light",
      },
      highlightOnHoverStyle: {
        backgroundColor: "#e3f2fd",
        transition: "0.2s ease-in-out",
      },
    },
    pagination: {
      style: {
        backgroundColor: "#1e1e1e",
        fontSize: "14px",
        borderTop: "1px solid #ddd",
        color: "#ffffff",
      },
      pageButtonsStyle: {
        color: "#ffffff",
        fill: "#ffffff",
        "&:hover": {
          backgroundColor: "#252525",
          color: "#ffffff",
          fill: "#ffffff",
        },
        "&:disabled": {
          color: "#bdbdbd",
          fill: "#bdbdbd",
        },
      },
    },
  };

  return (
    <div className="agent-lead">
      <h2 className="user-layout-page-heading">{type} <span className="float-right" style={{color: "#d4bb98", fontSize: "16px", cursor: "pointer"}} onClick={()=>{navigate("/admin-auth/admin-zips")}}><i class="bi bi-arrow-left-circle" style={{color: "#d4bb98", fontSize: "26px"}}></i></span></h2>
    {
      type && type === "Agents"?
      <>
       {loading ? (
            <div className="wait-loader">
              <div className="spinner-grow text-light" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <div className="container-fluid agent-buy-leads-container">
                 <Modal
                              centered
                              open={openResponsive}
                              footer={null}
                              closable={false}
                              width={{
                                xs: "100%",
                                sm: "100%",
                                md: "90%",
                                lg: "90%",
                                xl: "80%",
                                xxl: "65%",
                              }}
                            >
                              <div
                                className={`container-fluid pop-up-leads ${isMobile ? "px-0" : ""}`}
                              >
                                <img
                                  src="/img/pop-up-close.svg"
                                  className="img-fluid pop-up-close"
                                  onClick={() => setOpenResponsive(false)}
                                  role="button"
                                  alt=""
                                />
                                <div className={`container-fluid ${isMobile ? "px-0" : ""}`}>
                                  <div className="row">
                                    <div className="col-md-5">
                                      <div className="row">
                                        <div className="col-12">
                                          {selectedData ? (
                                            <div className="lending-header-box">
                                              <div className="lending-header-image">
                                                {selectedData.imageUrl ? (
                                                  <img
                                                    src={selectedData.imageUrl}
                                                    className="lending-image-media"
                                                    alt=""
                                                  />
                                                ) : (
                                                  <></>
                                                )}
                                              </div>
                                              <div className="lending-header-details">
                                                <h3
                                                  className="lending-header-details-name my-0"
                                                  style={{ textTransform: "capitalize" }}
                                                >
                                                  {selectedData.agentName}
                                                </h3>
                                                <span
                                                  className="badge rounded-pill ms-3 user-badge"
                                                  style={{
                                                    backgroundColor: "#1e1e1e!important",
                                                  }}
                                                >
                                                  {selectedData.accountStatus === "active"
                                                    ? "Active"
                                                    : "Inactive"}
                                                </span>
                                              </div>
                                            </div>
                                          ) : (
                                            <></>
                                          )}
                                        </div>
                                      </div>
                                      <div className="row mt-5 d-flex justify-content-center">
                                        <>
                                          <div className="col-md-6 d-flex align-items-center">
                                            <button
                                              onClick={() =>
                                                handleApprove2(selectedData._id, "active")
                                              }
                                              className="btn lead-allow-button"
                                            >
                                              Active
                                            </button>
                                          </div>
                                          <div className="col-md-6 d-flex align-items-center">
                                            <button
                                              onClick={() =>
                                                handleApprove2(selectedData._id, "deactive")
                                              }
                                              className="btn lead-deny-button"
                                            >
                                              Deactivate
                                            </button>
                                          </div>
                                        </>
              
                                        {/* {selectedData.tourStatus === "pending" ? (
                                  <>
                                    <div className="col-md-6">
                                      <button
                                        onClick={() => handleApprove(selectedData._id)}
                                        className="btn lead-allow-button"
                                      >
                                        Approve
                                      </button>
                                    </div>
                                    <div className="col-md-6">
                                      <button
                                        onClick={() => handleOpenReason(selectedData._id)}
                                        className="btn lead-deny-button"
                                      >
                                        Deny
                                      </button>
                                    </div>
                                  </>
                                ) : (
                                  <></>
                                )} */}
                                        {/* {selectedData.tourStatus === "approved" ? (
                                  <>
                                    <div className="col-md-6">
                                      <button
                                        onClick={() => handleOpenReason(selectedData._id)}
                                        className="btn lead-deny-button"
                                      >
                                        Deny
                                      </button>
                                    </div>
                                  </>
                                ) : (
                                  <></>
                                )} */}
                                      </div>
                                    </div>
                                    <div className="col-md-7">
                                      <div className="container-fluid lo-approve-right-card">
                                        <div className={`row ${isMobile ? "" : "h-100"}`}>
                                          <div className="col-md-12 d-flex flex-column justify-content-center h-100 gap-3">
                                            <div className="row">
                                              <div
                                                className={`col-md-5 ${isMobile ? "" : "pe-0"}`}
                                              >
                                                Email
                                              </div>
                                              <div
                                                className={`col-md-7 ${isMobile ? "" : "p-0"}`}
                                              >
                                                {selectedData.agentEmail}
                                              </div>
                                            </div>
                                            <div className="row">
                                              <div
                                                className={`col-md-5 ${isMobile ? "" : "pe-0"}`}
                                              >
                                                Number
                                              </div>
                                              <div
                                                className={`col-md-7 ${isMobile ? "" : "p-0"}`}
                                              >
                                                +1 {selectedData.agentPhone}
                                              </div>
                                            </div>
                                            <div className="row">
                                              <div
                                                className={`col-md-5 ${isMobile ? "" : "pe-0"}`}
                                              >
                                                Type
                                              </div>
                                              <div
                                                className={`col-md-7 ${isMobile ? "" : "p-0"}`}
                                              >
                                                {selectedData.agentVendorType}
                                              </div>
                                            </div>
                                            {selectedData.agentVendorType ===
                                            "Showing Agent" ? (
                                              <>
                                                <div className="row">
                                                  <div
                                                    className={`col-md-5 ${isMobile ? "" : "pe-0"}`}
                                                  >
                                                    Zip Codes
                                                  </div>
                                                  <div
                                                    className={`col-md-7 ${isMobile ? "" : "p-0"}`}
                                                  >
                                                    <Tooltip
                                                      title={
                                                        <div>
                                                          {selectedData.agentzipCode &&
                                                          selectedData.agentzipCode
                                                            .length > 0 ? (
                                                            selectedData.agentzipCode.map(
                                                              (service, index) => (
                                                                <span
                                                                  className="text-white"
                                                                  key={index}
                                                                >
                                                                  {service}
                                                                  <br />
                                                                </span>
                                                              )
                                                            )
                                                          ) : (
                                                            <span className="text-white">
                                                              No data available
                                                            </span>
                                                          )}
                                                        </div>
                                                      }
                                                      arrow
                                                      componentsProps={{
                                                        tooltip: {
                                                          sx: {
                                                            backgroundColor: "#333", // Background color
                                                            color: "white", // Text color
                                                            fontSize: "14px", // Optional: Adjust text size
                                                            borderRadius: "8px", // Optional: Rounded corners
                                                            padding: "10px", // Optional: Padding
                                                            fontFamily: "Degular-Light",
                                                          },
                                                        },
                                                        arrow: {
                                                          sx: {
                                                            color: "#333", // Arrow color to match tooltip background
                                                          },
                                                        },
                                                      }}
                                                    >
                                                      <span className="badge text-bg-dark">
                                                        View Zip Codes
                                                      </span>
                                                    </Tooltip>
                                                  </div>
                                                </div>
                                              </>
                                            ) : (
                                              <></>
                                            )}
                                            <div className="row">
                                              <div
                                                className={`col-md-5 ${isMobile ? "" : "pe-0"}`}
                                              >
                                                Status
                                              </div>
                                              <div
                                                className={`col-md-7 ${isMobile ? "" : "p-0"}`}
                                              >
                                                {selectedData.isVerified
                                                  ? "Verified"
                                                  : "Un Verified"}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Modal>
              
              <div className="row">
                {agentsData.length > 0 ? (
                  <div className="col-12 px-0 pt-4">
                    <DataTable
                      columns={columns}
                      data={agentsData}
                      pagination
                      paginationPerPage={15}
                      paginationRowsPerPageOptions={[10, 15, 20, 50]}
                      customStyles={customStyles}
                      progressPending={false}
                      progressComponent={
                        <div className="text-center my-2 bg-white">
                          <div
                            className="spinner-border text-secondary"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      }
                      className="table table-striped table-hover"
                    />
                  </div>
                ) : (
                  <div className="col-12 px-0 d-flex justify-content-center align-items-center flex-column">
                    <img
                      src="/img/leadership-empty.svg"
                      className="img-fluid"
                      alt=""
                    />
                    <h2 className="leadership-empty-heading">
                      It’s Empty here!
                    </h2>
                    <p className="leadership-empty-para mt-2">
                      Look’s like you haven’t scheduled any tours or offers.
                    </p>
                  </div>
                )}
              </div>
            </div>
          )}
      </>
      :
      <></>
    }
    {
      type && type === "Advertisers"?
      <>
     {loading ? (
              <div className="wait-loader">
                <div className="spinner-grow text-light" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <div className="container-fluid agent-buy-leads-container">
                <Modal
                  centered
                  open={openResponsive}
                  footer={null}
                  closable={false}
                  width={{
                    xs: "100%",
                    sm: "100%",
                    md: "90%",
                    lg: "90%",
                    xl: "80%",
                    xxl: "65%",
                  }}
                >
                  <div
                    className={`container-fluid pop-up-leads ${isMobile ? "px-0" : ""}`}
                  >
                    <img
                      src="/img/pop-up-close.svg"
                      className="img-fluid pop-up-close"
                      onClick={() => setOpenResponsive(false)}
                      role="button"
                      alt=""
                    />
                    <div className={`container-fluid ${isMobile ? "px-0" : ""}`}>
                      <div className="row">
                        <div className="col-md-5">
                          <div className="row">
                            <div className="col-12">
                              {selectedData ? (
                                <div className="lending-header-box">
                                  <div className="lending-header-image">
                                    {selectedData.imageUrl ? (
                                      <img
                                        src={selectedData.imageUrl}
                                        className="lending-image-media"
                                        alt=""
                                      />
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                  <div className="lending-header-details">
                                    <h3
                                      className="lending-header-details-name my-0"
                                      style={{ textTransform: "capitalize" }}
                                    >
                                      {selectedData.fulName?.slice(0, 12)}
                                    </h3>
                                    <span
                                      className="badge rounded-pill ms-3 user-badge"
                                      style={{
                                        backgroundColor: "#1e1e1e!important",
                                      }}
                                    >
                                      {selectedData.accountStatus === "active"
                                        ? "Active"
                                        : "Inactive"}
                                    </span>
                                  </div>
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                          <div className="row mt-5 d-flex justify-content-center">
                            <>
                              <div className="col-md-6 d-flex align-items-center">
                                <button
                                  onClick={() =>
                                    handleApprove(selectedData._id, "active")
                                  }
                                  className="btn lead-allow-button"
                                >
                                  Active
                                </button>
                              </div>
                              <div className="col-md-6 d-flex align-items-center">
                                <button
                                  onClick={() =>
                                    handleApprove(selectedData._id, "deactive")
                                  }
                                  className="btn lead-deny-button"
                                >
                                  Deactivate
                                </button>
                              </div>
                            </>
  
                            {/* {selectedData.tourStatus === "pending" ? (
                                <>
                                  <div className="col-md-6">
                                    <button
                                      onClick={() => handleApprove(selectedData._id)}
                                      className="btn lead-allow-button"
                                    >
                                      Approve
                                    </button>
                                  </div>
                                  <div className="col-md-6">
                                    <button
                                      onClick={() => handleOpenReason(selectedData._id)}
                                      className="btn lead-deny-button"
                                    >
                                      Deny
                                    </button>
                                  </div>
                                </>
                              ) : (
                                <></>
                              )} */}
                            {/* {selectedData.tourStatus === "approved" ? (
                                <>
                                  <div className="col-md-6">
                                    <button
                                      onClick={() => handleOpenReason(selectedData._id)}
                                      className="btn lead-deny-button"
                                    >
                                      Deny
                                    </button>
                                  </div>
                                </>
                              ) : (
                                <></>
                              )} */}
                          </div>
                        </div>
                        <div className="col-md-7">
                          <div className="container-fluid lo-approve-right-card">
                            <div className={`row ${isMobile ? "" : "h-100"}`}>
                              <div className="col-md-12 d-flex flex-column justify-content-center h-100 gap-3">
                                <div className="row">
                                  <div
                                    className={`col-md-5 ${isMobile ? "" : "pe-0"}`}
                                  >
                                    Email
                                  </div>
                                  <div
                                    className={`col-md-7 ${isMobile ? "" : "p-0"}`}
                                  >
                                    {selectedData.email}
                                  </div>
                                </div>
                                <div className="row">
                                  <div
                                    className={`col-md-5 ${isMobile ? "" : "pe-0"}`}
                                  >
                                    Number
                                  </div>
                                  <div
                                    className={`col-md-7 ${isMobile ? "" : "p-0"}`}
                                  >
                                    +1 {selectedData.phoneNumber}
                                  </div>
                                </div>
                                <div className="row">
                                  <div
                                    className={`col-md-5 ${isMobile ? "" : "pe-0"}`}
                                  >
                                    Company
                                  </div>
                                  <div
                                    className={`col-md-7 ${isMobile ? "" : "p-0"}`}
                                  >
                                    {selectedData.titleCompany}
                                  </div>
                                </div>
                                <div className="row">
                                  <div
                                    className={`col-md-5 ${isMobile ? "" : "pe-0"}`}
                                  >
                                    Zip Codes
                                  </div>
                                  <div
                                    className={`col-md-7 ${isMobile ? "" : "p-0"}`}
                                  >
                                    <Tooltip
                                      title={
                                        <div>
                                          
                                          {selectedData.advertiserBussninesinfo && selectedData.advertiserBussninesinfo
                                            .areaof_Operation?.length > 0 ? (
                                            selectedData.advertiserBussninesinfo.areaof_Operation.map(
                                              (service, index) => (
                                                <span
                                                  className="text-white"
                                               
                                                  key={index}
                                                >
                                                  {service}
                                                  <br />
                                                </span>
                                              )
                                            )
                                          ) : (
                                            <span className="text-white">
                                              No data available
                                            </span>
                                          )}
                                        </div>
                                      }
                                      arrow
                                      componentsProps={{
                                        tooltip: {
                                          sx: {
                                            backgroundColor: "#333", // Background color
                                            color: "white", // Text color
                                            fontSize: "14px", // Optional: Adjust text size
                                            borderRadius: "8px", // Optional: Rounded corners
                                            padding: "10px", // Optional: Padding
                                            fontFamily: "Degular-Light"
                                          },
                                        },
                                        arrow: {
                                          sx: {
                                            color: "#333", // Arrow color to match tooltip background
                                          },
                                        },
                                      }}
                                    >
                                      <span className="badge text-bg-dark">
                                        View Zip Codes
                                      </span>
                                    </Tooltip>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Modal>
  
                <div className="row">
                  {advertisersData.length > 0 ? (
                    <div className="col-12 px-0 pt-4">
                      <DataTable
                        columns={columns2}
                        data={advertisersData}
                        pagination
                        paginationPerPage={15}
                        paginationRowsPerPageOptions={[10, 15, 20, 50]}
                        customStyles={customStyles}
                        progressPending={false}
                        progressComponent={
                          <div className="text-center my-2 bg-white">
                            <div
                              className="spinner-border text-secondary"
                              role="status"
                            >
                              <span className="visually-hidden">Loading...</span>
                            </div>
                          </div>
                        }
                        className="table table-striped table-hover"
                      />
                    </div>
                  ) : (
                    <div className="col-12 px-0 d-flex justify-content-center align-items-center flex-column">
                      <img
                        src="/img/leadership-empty.svg"
                        className="img-fluid"
                        alt=""
                      />
                      <h2 className="leadership-empty-heading">
                        It’s Empty here!
                      </h2>
                      <p className="leadership-empty-para mt-2">
                        Look’s like you haven’t any data to display.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            )}
      </>
      :
      <></>
    }
     
    </div>
  );
}

export default ZipCodeDetail;
